import { Injectable, inject } from '@angular/core';
import { MbsSize, ModalService } from 'mbs-ui-kit';
import { BuyPremiumSupportModalComponent } from 'mbs-ui-shared@components/licenses/components/buy-premium-support-modal/buy-premium-support-modal.component';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LicensesSignalFacade } from 'mbs-ui-shared@facades/licenses-signal.facade';

@Injectable({
  providedIn: 'root'
})
export class PremiumSupportService {
  private licensesSignalFacade = inject(LicensesSignalFacade);
  private authFacade = inject(AuthFacade);
  private modalService = inject(ModalService);

  public readonly hasPremiumSupportLicense = this.licensesSignalFacade.hasPremiumSupportLicense;

  public open(): void {
    if (this.hasPremiumSupportLicense()) {
      this.authFacade.redirectToSupportPortal();

      return;
    }

    this.openBuyModal();
  }

  public openBuyModal(): void {
    this.modalService.openCustom(BuyPremiumSupportModalComponent, { size: MbsSize.md });
  }
}
